module.exports = __webpack_public_path__ + "static/media/9.8ec0d42c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/9.png
// module id = 788
// module chunks = 0